const API_BASE_URL = process.env.BASE_URL

export const JOB_ENDPOINTS = {
    UPDATE: API_BASE_URL + "/{service_company_slug}/api/jobs/{id}/",
    PREVIEW: API_BASE_URL + "/{service_company_slug}/api/jobs/{id}/preview/",
}

export const JOB_LABELS = {
    LIST: API_BASE_URL + "/{service_company_slug}/api/jobs/labels/",
}
